import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListTicket, updateDataSearch } from "../../actions/Ticket";
import { Headersubfull } from "../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import { TableTicket } from "./TableTicket";
import { AddTicketBtn } from "./AddTicket";
import ticketApi from "service/ticketApi";
import LayoutV2 from "containers/LayoutV2";

export const Ticket = () => {
  const dispatch = useDispatch();
  const [dataTicket, setDataTicket] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchTicket);
  useEffect(() => {
    document.title = "Ticket | Phần mềm quản lý cầm đồ Morman";
    onSearch();
  }, []);
  const onSearch = () => {
    ticketApi
      .list({
        trangThai: dataSearch.trangThai,
        tieude: dataSearch.tieude,
        pageSize: dataSearch.pageSize,
        pageIndex: dataSearch.pageIndex,
      })
      .then((response) => {
        if (response.status == "200") {
          setDataTicket(response.data);
        }
      });
  };
  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div class="row header">
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/icon-logo-quan-ly-thu-chi.png"
                          alt=""
                        />
                        <h1 className="text-info-home">Ticket</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                <div className="card-body card-body-v2">
                  <SearchBarDesktop onSearch={onSearch} />
                </div>
              </div>
              {/* <div className="breadcrumb-new hidden-mobile-main show-table-main">
                <div className="row">
                  <Headersubfull title="Ticket" icon1="mdi mdi-warehouse" />
                  <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main">
                  </div>
                </div>
                <SearchBarDesktop onSearch={onSearch} />
              </div>   */}
            </div>
            <SearchBarMobile onSearch={onSearch} />
            <AddTicketBtn />

            <TableTicket dataTicket={dataTicket} onSearch={onSearch} />
          </div>
        </div>
      </div>
    </LayoutV2>
  );
};
